export default __webpack_public_path__ + "static/media/fi_arrow-right.ab093d22.svg";